import { Component, Input, OnInit } from '@angular/core';
import { ModalClass } from '@app/core/class/modal.class';
import { AnnouncementModel } from '@app/core/model/announcement.model';
import { AnnouncementListService } from '@app/core/service/announcement-list.service';
import { ToastService } from '@app/core/service/toast.service';
import {
  EAnnouncementActions,
  EAnnouncementRespondButtonText
} from '@backend/models/types/announcement';
import {
  AlertController,
  LoadingController,
  ModalController
} from '@ionic/angular';

@Component({
  selector: 'app-announcement-respond-modal',
  templateUrl: './announcement-respond-modal.component.html',
  standalone: false
})
export class AnnouncementRespondModalComponent
  extends ModalClass
  implements OnInit
{
  @Input()
  public announcement: AnnouncementModel;

  @Input()
  public buttonText = '';

  protected readonly announcementActions = EAnnouncementActions;
  protected readonly announcementRespondButtonText =
    EAnnouncementRespondButtonText;

  protected body = '';

  public constructor(
    private readonly _modalCtrl: ModalController,
    private readonly _loadingCtrl: LoadingController,
    private readonly _toastService: ToastService,
    private readonly _announcementListService: AnnouncementListService,
    private readonly _alertCtrl: AlertController
  ) {
    super('AnnouncementRespondModalComponent');
  }

  public async ngOnInit() {
    if (this.announcement.taskAudit) {
      const alert = await this._alertCtrl.create({
        cssClass: 'wide-alert',
        header: 'Task Audit Feedback',
        subHeader: 'Your feedback will be shared with audit reviewers',
        buttons: [
          {
            role: 'confirm',
            text: 'OK'
          }
        ]
      });
      alert.present();
    }
  }

  protected onCloseClick(role = 'cancel') {
    this._modalCtrl.dismiss(null, role, this._modalName);
  }

  protected async onRespondClick() {
    const loading = await this._loadingCtrl.create({
      message: 'Sending...'
    });
    loading.present();

    this._announcementListService
      .respondToAnnouncement(this.announcement._id, {
        body: this.body
      })
      .subscribe({
        next: () => {
          loading.dismiss();
          this._toastService.presentToast('Message Sent Successfully!');
          this.onCloseClick('confirm');
        },
        error: () => {
          loading.dismiss();
          this._toastService.presentToast('Unable to Send Message');
        }
      });
  }

  protected get bodyPlaceholder() {
    return this.announcement.respondButtonText ===
      this.announcementRespondButtonText.REQUEST_CLARIFICATION
      ? 'Please provide a short message to help the sender understand what you’d like to better understand'
      : 'Message';
  }
}
